export default __webpack_public_path__ + "fonts/check-circle-inactive.svg";